import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import servicosCargo from "../../servicos/servicos-cargo";
import { Form } from "semantic-ui-react";
import MenuLateral from "../components/MenuLateral";
import NavMenu from "../components/Nav";
import { ToastContainer, toast } from 'react-toastify';
import Edit from "../../img/svgs/Edit";
import Cancel from "../../img/svgs/Cancel";
import Salvar from "../../img/svgs/Salvar";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../../utils/localizedTextsMap";

const ListCargos = () => {
  const [cargos, setCargos] = useState([]);
  const [valor, setValor] = useState();
  const [editado, setEditado] = useState(false)
  const [show, setShow] = useState(false);
  const [showConfirmacao, setShowConfirmacao] = useState(false);
  const containerRef = useRef(null);
  const [idCargo, setIdCargo] = useState();
  const nome_cargo = useRef();
  const [invalido, setInvalido] = useState(false);

  useEffect(() => {
    function getDados() {
      servicosCargo.listarTodos()
        .then(response => {
          if (response.status === 200) {
            setCargos(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, [editado]);

  const handleClose = () => setShow(false);

  const handleShow = (cargo) => {
    setInvalido(false);
    setValor(cargo);
    setIdCargo(cargo.id_cargo);
    setShow(true);
  }
  const handleCloseConfirmacao = () => setShowConfirmacao(false);

  const handleShowConfirmacao = () => {
    const nome = document.querySelector("#nome_cargo");
    if (String(nome.value).length < 2) {
      setInvalido(true);
    } else {
      setInvalido(false);
      setShow(false);
      setShowConfirmacao(true);
    }
  }


  const editarCargo = (nome) => {
    setEditado(false);
    const data = {
      "nome_cargo": nome
    }
    servicosCargo.editar(idCargo, data).then(response => {
      if (response.status === 200) {
        toast.success("Cargo alterado com sucesso!", {
          theme: "colored",
        });
        setEditado(true);
      }
    }).catch(error => {
      console.log(error);
      toast.error("Não foi possível alterar o Cargo!", {
        theme: "colored"
      });
    })
    handleCloseConfirmacao();
    handleClose()
  }


  const columnsCargo = [
    { field: "id_cargo", headerName: "ID", width: 45 },
    {
      field: "nome_cargo",
      headerName: "Nome",
      width: 250,
      editable: true,
    },
    {
      field: "operacao",
      headerName: "Editar",
      width: 90,
      renderCell: (params) => {
        return <button className="btn-icones rounded p-1" size="sm" onClick={() => handleShow(params.row)}><Edit /> Editar</button>
      }
    }
  ];

  const ModalConfirmacao = (props) => {
    return <>
      <div >
        <Modal className="modal-confirmacao" show={showConfirmacao} onHide={handleCloseConfirmacao}>
          <Modal.Body className="">
            <span>Você deseja alterar o nome do cargo para <strong>{props.nome}</strong>?</span>
          </Modal.Body>
          <Modal.Footer >
            <button type="button" className="btn-icones p-1 rounded w-25" onClick={() => editarCargo(props.nome)}><Salvar /> Salvar</button>
            <button type="button" className="btn-icones p-1 rounded w-25" onClick={handleCloseConfirmacao}><Cancel /> Cancelar</button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  }

  const ModalEditar = () => {
    return <>

      <Modal className="modal-mae  modal-lg" show={show} onHide={handleClose}>
        {/* <Modal.Header closeButton>
            <Modal.Title>Edição Colaboradores</Modal.Title>
          </Modal.Header> */}
        <Modal.Body className="" >
          <div ref={containerRef}>
            <Form >
              <div className="d-flex justify-content-center">
                <div>

                  <Form.Field className="mx-5">
                    <label htmlFor="nome_cargo" className="form-label label-texto">Nome</label>
                    <input className="input-cadastro" id="nome_cargo" defaultValue={valor?.nome_cargo} ref={nome_cargo}></input>
                    {invalido && <p className="errosValidacao">Requerido mínimo 2 letras</p>}
                  </Form.Field>

                  <div className="text-center">
                    <button className="me-2 w-25 btn-icones rounded p-1" type="button" onClick={handleShowConfirmacao}>
                      <Salvar /> Salvar
                    </button>
                    <button className="btn-icones w-25 rounded p-1" onClick={handleClose}>
                      <Cancel /> Cancelar
                    </button>
                  </div>

                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }
  return (
    <>
      <NavMenu />
      <ModalConfirmacao className="modal-confirmacao" nome={nome_cargo?.current?.value} />
      <ToastContainer />
      <div className="d-flex container">
        <div className="w-25">
          <MenuLateral />
        </div>
        <div className="w-75">
          <ModalEditar />
          <div  className="tabelas-gerenciais">
            <h3 className="text-start subtitulo" style={{fontSize: 20}}>Lista de Cargos</h3>

            <Box sx={{ height: 650, width: 950, marginTop: 2}}>
              <DataGrid

                style={{ borderRadius: "20px" }}
                localeText={localizedTextsMap}
                rows={cargos}
                columns={columnsCargo}
                pageSize={10}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                getRowId={(row) => row.id_cargo}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
                }
              />
            </Box>


          </div>
        </div>
      </div>
    </>
  );
};

export default ListCargos;